<template>
	<Row class="flex-align-center flex-justify-space-between pa-2 width-100 item-container">
		<Row class="flex-align-center">
			<Col class="empty-moon flex-centerize">
				<SIcon name="successful-suggestion" height="25" width="25" v-if="isCompleted" />
			</Col>
			<h3 class="heavy ml-2">{{ title }}</h3>
		</Row>
		<Row class="flex-align-center">
			<h5 :class="[isCompleted ? 'completed' : isRequired ? 'required' : '']" class="reg text-align-right description">
				{{ isCompleted ? 'Completed' : isRequired ? 'Required' : 'Optional' }}
			</h5>
			<v-icon color="#64666A" size="16" class="ml-3">mdi-chevron-right</v-icon>
		</Row>
	</Row>
</template>
<script>
export default {
	name: 'BeforeShareRecommendationItem',
	components: {},
	props: {
		title: { type: String },
		isRequired: { type: Boolean },
		isCompleted: { type: Boolean },
	},
};
</script>
<style scoped lang="scss">
.empty-moon {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background: #f4f6f9;
	border: 1px solid #d6ddea;
}

.item-container {
	cursor: pointer;
	border-radius: 9px;
	background: var(--white);
	border: 1px solid transparent;
	transition: var(--transition-time);
	&:hover {
		border: 1px solid #5b5be7;
		box-shadow: 0px 3px 6px #00000029;
		transition: var(--transition-time);
	}
}
.description {
	color: #26262680;
	letter-spacing: 0px;
	&.required {
		color: #5858ec;
		font-weight: 600;
	}
	&.completed {
		color: #4bcca2;
		font-weight: 600;
	}
}
</style>
